import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../lib/api';
import { useAuth } from '../../../contexts/AuthContext';
import type { AtticSpace } from './ventilation';
export interface Plan { spaces: AtticSpace[]; revision: number; updated_at: string | null }
export function useVentilationPlan(measurementId: number) {
  const { user } = useAuth();
  const client = useQueryClient();
  const key = ['ventilation-plan', user?.id, user?.organization?.id, measurementId];
  const url = `/api/measurements/${measurementId}/ventilation/`;
  const query = useQuery({ queryKey: key, queryFn: async () => (await api.get<Plan>(url)).data });
  const save = useMutation({
    mutationFn: async (plan: Plan) => (await api.put<Plan>(url, { spaces: plan.spaces, revision: plan.revision })).data,
    onSuccess: data => client.setQueryData(key, data),
  });
  return { ...query, save };
}
